import { Recaptcha } from 'constants/ApiErrors'

export const isRecapthcaLowScoreError = (errorMessage: string): boolean => {
  return errorMessage === Recaptcha.LOW_SCORE
}
